import { createRestSlice } from "./restSlice";

export type OrganizationSecret = {
  id: string;
  organizationId: string;
  name: string;
  value?: string;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date | null;
};

const organizationSecretsSlice = createRestSlice<OrganizationSecret>("organizationSecrets", "/v1/organization-secrets");

export const organizationSecretsReducer = organizationSecretsSlice.reducer;
export const organizationSecretsActions = organizationSecretsSlice.actions;
